export default __webpack_public_path__ + "static/media/team_m.10374d53.jpg";